export enum ImprovementsTab {
  All = "all",
  Standard = "standard",
  Unique = "unique",
}
